module.exports = __webpack_public_path__ + "static/media/The_House_Of_Bohemian_Champions_Mashup.92752223.mp3";